// extracted by mini-css-extract-plugin
export default {"mainContainer":"Rules_mainContainer__NEVXX","subContainer":"Rules_subContainer__okGHu"};